import { FunctionFactory } from "survey-core";
import { calculateProteinRange } from "../features/calculations";
import { BodyFat } from "./bodyfat";
import { Goals } from "./goals";
import { WeightUnit, getWeightPounds } from "./weight";
import { loc } from "../i18n/survey";

enum ProteinTracking {
  NoIdea = "NoIdea",
  EatingMore = "EatingMore",
  EatingLess = "EatingLess",
  PrettyClose = "PrettyClose",
}

const proteinQuestion = {
  name: "protein",
  title: loc("quiz.protein.title"),
  description: loc("quiz.protein.description"),
  type: "radiogroup",
  choices: [
    {
      value: ProteinTracking.NoIdea,
      text: loc("quiz.intake.noIdea"),
    },
    {
      value: ProteinTracking.EatingMore,
      text: loc("quiz.intake.eatingMore"),
    },
    {
      value: ProteinTracking.EatingLess,
      text: loc("quiz.intake.eatingLess"),
    },
    {
      value: ProteinTracking.PrettyClose,
      text: loc("quiz.intake.prettyClose"),
    },
  ],
  isRequired: true,
};

const goalProteinTextExpression = {
  name: "goalProteinText",
  expression: "renderGoalProteinText({goals})",
};

const proteinTextExpression = {
  name: "proteinText",
  expression: "renderProteinText({weightUnit}, {weight}, {bodyFat})",
};

function renderGoalProteinText(params: any[]): string {
  const goals = params[0] as Goals;
  switch (goals) {
    case Goals.LoseFat:
      return `To build muscle and keep your metabolism high as you lose weight,`;
    case Goals.BuildMuscle:
      return `To maximize muscle growth,`;
    case Goals.BuildMuscleAndLoseFat:
      return `To maintain/build muscle as you lose fat,`;
  }
}

function renderProteinText(params: any[]): string {
  if (params === undefined || params === null) return "";
  const weightUnit = params[0] as WeightUnit;
  const weightPounds = getWeightPounds(params[1] as number, weightUnit);
  const bodyFat = params[2] as BodyFat;
  const proteinRange = calculateProteinRange(bodyFat, weightPounds);

  // Use midpoint of min and max
  return Math.round((proteinRange[0] + proteinRange[1]) / 2).toFixed(0);
}

/**
 * The daily protein target (grams) the quiz shows ("around X grams"), or
 * undefined when the answers it needs are missing. web42: passed through
 * checkout (protein_target_g) so the post-purchase protein offer can repeat it.
 */
function getProteinTargetG(user?: { weightUnit?: unknown; weight?: unknown; bodyFat?: unknown } | null): number | undefined {
  if (!user || user.weightUnit == null || user.weight == null || user.bodyFat == null) return undefined;
  try {
    const grams = Number(renderProteinText([user.weightUnit, user.weight, user.bodyFat]));
    return Number.isFinite(grams) && grams > 0 ? Math.round(grams) : undefined;
  } catch {
    return undefined;
  }
}

FunctionFactory.Instance.register('renderGoalProteinText', renderGoalProteinText);
FunctionFactory.Instance.register('renderProteinText', renderProteinText);

export {
  ProteinTracking,
  goalProteinTextExpression,
  proteinQuestion,
  proteinTextExpression,
  renderProteinText,
  getProteinTargetG,
};

